import React from 'react';
import ReactDOM from 'react-dom/client';

// 1. Importer votre Fichier CSS Global
// (Assurez-vous que le chemin est correct)
import './global.css'; 

// 2. Importer votre composant App principal
import App from './App.js'; 

// 3. Trouver l'élément 'root' dans votre HTML
const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

// 4. Rendre votre application
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
